var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormGroup from "../Components/FormGroup.vue";
import ProfilePicture from "../Components/ProfilePicture.vue";
import ImageEditor from "../Components/ImageEditor.vue";
import { stripDataUri } from "../Helpers/Image.ts";
var PersonalInformation = /** @class */ (function (_super) {
    __extends(PersonalInformation, _super);
    function PersonalInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localAvatarUrl = _this.avatarUrl || null;
        _this.localAvatarBytes = _this.avatarBytes || null;
        _this.localAvatarCrop = _this.avatarCrop || null;
        _this.localAvatarFileName = _this.avatarFileName || null;
        _this.localPrefix = _this.prefix || null;
        _this.localFirstName = _this.firstName || null;
        _this.localMiddleName = _this.middleName || null;
        _this.localLastName = _this.lastName || null;
        _this.localSuffix = _this.suffix || null;
        _this.stripDataUri = stripDataUri;
        return _this;
    }
    PersonalInformation.prototype.onAvatarUrlChanged = function (val) { this.$emit("update:avatarUrl", val); };
    PersonalInformation.prototype.onAvatarBytesChanged = function (val) { this.$emit("update:avatarBytes", val); };
    PersonalInformation.prototype.onAvatarCropChanged = function (val) { this.$emit("update:avatarCrop", val); };
    PersonalInformation.prototype.onAvatarFileNameChanged = function (val) { this.$emit("update:avatarFileName", val); };
    PersonalInformation.prototype.onPrefixChanged = function (val) { this.$emit("update:prefix", val); };
    PersonalInformation.prototype.onFirstNameChanged = function (val) { this.$emit("update:firstName", val); };
    PersonalInformation.prototype.onMiddleNameChanged = function (val) { this.$emit("update:middleName", val); };
    PersonalInformation.prototype.onLastNameChanged = function (val) { this.$emit("update:lastName", val); };
    PersonalInformation.prototype.onSuffixChanged = function (val) { this.$emit("update:suffix", val); };
    __decorate([
        Prop({ type: Object, required: true })
    ], PersonalInformation.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], PersonalInformation.prototype, "$v", void 0);
    __decorate([
        Prop({ type: String, default: "avatar" })
    ], PersonalInformation.prototype, "$vAvatar", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "avatarUrl", void 0);
    __decorate([
        Watch("localAvatarUrl")
    ], PersonalInformation.prototype, "onAvatarUrlChanged", null);
    __decorate([
        Prop({ type: String, default: "avatarUrl" })
    ], PersonalInformation.prototype, "mAvatarUrl", void 0);
    __decorate([
        Prop({ type: String, default: "avatarUrl" })
    ], PersonalInformation.prototype, "$vAvatarUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "avatarBytes", void 0);
    __decorate([
        Watch("localAvatarBytes")
    ], PersonalInformation.prototype, "onAvatarBytesChanged", null);
    __decorate([
        Prop({ type: String, default: "avatarBytes" })
    ], PersonalInformation.prototype, "mAvatarBytes", void 0);
    __decorate([
        Prop({ type: String, default: "avatarBytes" })
    ], PersonalInformation.prototype, "$vAvatarBytes", void 0);
    __decorate([
        Prop({ type: Object })
    ], PersonalInformation.prototype, "avatarCrop", void 0);
    __decorate([
        Watch("localAvatarCrop")
    ], PersonalInformation.prototype, "onAvatarCropChanged", null);
    __decorate([
        Prop({ type: String, default: "avatarCrop" })
    ], PersonalInformation.prototype, "mAvatarCrop", void 0);
    __decorate([
        Prop({ type: String, default: "avatarCrop" })
    ], PersonalInformation.prototype, "$vAvatarCrop", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "avatarFileName", void 0);
    __decorate([
        Watch("localAvatarFileName")
    ], PersonalInformation.prototype, "onAvatarFileNameChanged", null);
    __decorate([
        Prop({ type: String, default: "avatarFileName" })
    ], PersonalInformation.prototype, "mAvatarFileName", void 0);
    __decorate([
        Prop({ type: String, default: "avatarFileName" })
    ], PersonalInformation.prototype, "$vAvatarFileName", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "prefix", void 0);
    __decorate([
        Watch("localPrefix")
    ], PersonalInformation.prototype, "onPrefixChanged", null);
    __decorate([
        Prop({ type: String, default: "prefix" })
    ], PersonalInformation.prototype, "mPrefix", void 0);
    __decorate([
        Prop({ type: String, default: "prefix" })
    ], PersonalInformation.prototype, "$vPrefix", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "firstName", void 0);
    __decorate([
        Watch("localFirstName")
    ], PersonalInformation.prototype, "onFirstNameChanged", null);
    __decorate([
        Prop({ type: String, default: "firstName" })
    ], PersonalInformation.prototype, "mFirstName", void 0);
    __decorate([
        Prop({ type: String, default: "firstName" })
    ], PersonalInformation.prototype, "$vFirstName", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "middleName", void 0);
    __decorate([
        Watch("localMiddleName")
    ], PersonalInformation.prototype, "onMiddleNameChanged", null);
    __decorate([
        Prop({ type: String, default: "middleName" })
    ], PersonalInformation.prototype, "mMiddleName", void 0);
    __decorate([
        Prop({ type: String, default: "middleName" })
    ], PersonalInformation.prototype, "$vMiddleName", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "lastName", void 0);
    __decorate([
        Watch("localLastName")
    ], PersonalInformation.prototype, "onLastNameChanged", null);
    __decorate([
        Prop({ type: String, default: "lastName" })
    ], PersonalInformation.prototype, "mLastName", void 0);
    __decorate([
        Prop({ type: String, default: "lastName" })
    ], PersonalInformation.prototype, "$vLastName", void 0);
    __decorate([
        Prop({ type: String })
    ], PersonalInformation.prototype, "suffix", void 0);
    __decorate([
        Watch("localSuffix")
    ], PersonalInformation.prototype, "onSuffixChanged", null);
    __decorate([
        Prop({ type: String, default: "suffix" })
    ], PersonalInformation.prototype, "mSuffix", void 0);
    __decorate([
        Prop({ type: String, default: "suffix" })
    ], PersonalInformation.prototype, "$vSuffix", void 0);
    PersonalInformation = __decorate([
        Component({
            name: "PersonalInformation",
            components: {
                FormGroup: FormGroup,
                ProfilePicture: ProfilePicture,
                ImageEditor: ImageEditor
            }
        })
    ], PersonalInformation);
    return PersonalInformation;
}(Vue));
export default PersonalInformation;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/PersonalInformation.vue
// module id = 872
// module chunks = 6